import Layout from "./../../../Components/Navbar";
import React from "react";
import {
  GlobelInvesting,
  OverseasEducation,
  Payglobel,
  ProtectDepreciation,
  ReadySetGo,
} from "./../../../Public/assets/index";

function SignUpFlow({ children, headerText, ParagraphText, styleProps }) {
  return (
    <>
      <Layout noToggle={false}>
        <div className=" mt-[63px] min-h-[calc(100dvh-208px)] sm:min-h-[calc(100dvh-152px)] lg:mt-[90px] lg:mb-[10px] xl:mt-[80px] xl:mb-0 h725:sm:h-[calc(100dvh-152px)]  h725:lg:h-[calc(100dvh-186px)]  flex items-center justify-center  md:rounded-lg px-6 xl:px-40  ">
          <div className="w-full max-w-[1120px] lg:max-h-[600px] flex  flex-col lg:flex-row lg:shadow-walletShadow lg:rounded-2xl ">
            <div className="w-full lg:!w-1/2  py-5 lg:px-[26px] lg:py-[30px]  text-blackShade  ">
              <div className={`w-full ${styleProps}  `}>
                {headerText && (
                  <h1 className=" text-[26px] leading-[34px] mb-[5px] font-geomanistMedium text-blackish ">
                    {headerText}
                  </h1>
                )}
                {ParagraphText && (
                  <p className="text-sm  mb-[24px] xl:mb-[36px] text-greyish font-geomanistRegular">
                    {ParagraphText}
                  </p>
                )}
                {children}
              </div>
            </div>

            <div className=" hidden  lg:block  lg:!w-1/2 lg:h-[600px]   text-white ">
              <div
                // w-[562px] h-[419px]
                className=" bg-cover h-full rounded-r-2xl flex flex-col justify-end"
                style={{
                  backgroundImage: `url(${ReadySetGo})`,
                }}
              >
                <h1 className="text-[42px] leading-[55px]  ml-[25px] font-geomanistMedium">
                  Borderless Money
                </h1>
                <p className=" ml-[25px]  text-[16px] leading-[25px] font-geomanistRegular">
                  Save, invest and spend on your global lifestyle with a
                  multi-currency account.
                </p>

                <div className="flex justify-between flex-wrap !pt-[15px] !pb-[43px] !px-[25px]  gap-[34px] rounded-2xl ">
                  <div className="flex items-start   w-2/5  space-x-2">
                    <img src={Payglobel} alt="" className="mt-1" />

                    <div className=" gap-[6px] ">
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        Pay for global
                      </span>
                      <br />
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        living expenses
                      </span>
                    </div>
                  </div>

                  <div className="flex items-start  w-2/5 space-x-2">
                    <img src={GlobelInvesting} alt="" className="mt-1" />
                    <div className=" gap-[6px] ">
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        Save money for
                      </span>
                      <br />
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        global investing
                      </span>
                    </div>
                  </div>

                  <div className="flex items-start   w-2/5  space-x-2">
                    <img src={OverseasEducation} alt="" className="mt-1" />
                    <div className=" gap-[6px] ">
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        Save money for
                      </span>
                      <br />
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        overseas education
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start   w-2/5  space-x-2">
                    <img src={ProtectDepreciation} alt="" className="mt-1" />

                    <div className=" gap-[6px] ">
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        Protect against
                      </span>
                      <br />
                      <span className="text-white font-geomanistBold text-[16px]  ">
                        currency depreciation
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default SignUpFlow;
